module.exports = __webpack_public_path__ + "img/38ne.3d1a9fe7.svg";